import { apiSlice } from "../apiSlice";

const storeApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getStoreList: builder.query({
            query: (id) => {
                return {
                    url: `/api/merchant-store/list/${id}`,
                    method: 'GET',
                }
            },
            providesTags: ['storeList']
        }),
        createStore: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/merchant-store/create`,
                    method: 'POST',
                    body
                }
            },
            invalidatesTags: ['storeList']
        }),
        updateStore: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/merchant-store/update/${body.storeId}`,
                    method: 'PATCH',
                    body: body.data
                }
            },
            invalidatesTags: ['storeList']
        }),
        deleteStore: builder.mutation({
            query: (id) => {
                return {
                    url: `/api/merchant-store/delete/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['storeList']
        }),
    }),
    overrideExisting: true,
});

export const { useGetStoreListQuery, useCreateStoreMutation, useUpdateStoreMutation, useDeleteStoreMutation } = storeApiSlice;
